<template>
  <div>
    <div v-if="loadingState === LoadingState.LOADING" class="shine d-block"></div>
    <template v-else-if="errorMessages.parentGoals">
      <div class="field-error-message" v-for="message in errorMessages.parentGoals" :key="message">
        {{ message }}
      </div>
    </template>
    <div v-else>
      <div class="d-flex align-items-center" v-for="pGoal in parentGoals" :key="pGoal.id">
        <i class="goal-icon-greyed flex-shrink-0 mr-2"></i>
        <div class="text-medium-1 bold text-truncate" :title="pGoal.title" v-no-capture>
          {{ pGoal.title }}
        </div>
        <link-button class="text-small py-1" @click="$emit('remove', pGoal.id)"
          >Remove
        </link-button>
      </div>
      <div class="d-flex align-items-baseline">
        <div class="mr-2 text-nowrap" v-if="parentGoals.length === 0">
          Not selected
        </div>
        <b-button
          class="text-nowrap text-medium px-0 underline"
          variant="link"
          @click="parentGoalModalShown = true"
          >Pick parent goals
        </b-button>
      </div>
      <parent-goals-alignment
        :org-id="orgId"
        :sub-org-id="subOrgId"
        :goal="goal"
        :save-on-submit="false"
        :selected-parent-goals="parentGoals"
        v-model="parentGoalModalShown"
        @select="$emit('select', $event)"
        v-if="parentGoalModalShown"
      />
    </div>
  </div>
</template>

<script>
import { LoadingState } from '@/constants/common'
import { BButton } from 'bootstrap-vue'
import LinkButton from '@/components/buttons/LinkButton'
import ParentGoalsAlignment from '@/components/goal/ParentGoalsAlignment'

/**
 * This lists the attached parentGoals and give an option to attach/remove more parent goals
 */
export default {
  name: 'EditParentGoals',
  props: ['goal', 'errorMessages', 'orgId', 'subOrgId', 'parentGoals', 'loadingState'],
  components: {
    ParentGoalsAlignment,
    LinkButton,
    BButton
  },
  data() {
    return {
      parentGoalModalShown: false,
      LoadingState
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/errors';

.shine {
  width: 200px;
  height: 21px;
  margin: 6px 0;
}
</style>
